import events from '../events/events';

const Confirm = {};

/**
 * Confirm plugin
 *
 * @param Vue
 * @param options
 */
Confirm.install = function(Vue, options)
{
    let methods =
    {
        /**
         * Show confirm and set content
         *
         * @param {String} headline
         * @param {String} content
         * @param {Object} callback
         * @param {Object} label
         */
        show(headline, content, callback, label, html)
        {
            // push confirm on event bus
            events.$emit('confirm.open', headline, content, callback, label, html);
        },
    };

    // register global methods
    Vue.confirm = methods;

    // register instance methods
    Vue.prototype.$confirm = methods;
};

export default Confirm;



// WEBPACK FOOTER //
// ./src/js/plugins/confirm.js